import { useCallback } from 'react';

export function useAnalytics() {
  const trackEvent = useCallback((eventName: string, data: Record<string, any>) => {
    // Here you would typically send the event to your analytics service
    console.log('Analytics event:', eventName, data);
    
    // Track timing
    const timing = {
      timestamp: new Date().toISOString(),
      timeOnPage: Math.floor((Date.now() - window.performance.timing.navigationStart) / 1000),
    };

    // Collect performance metrics
    const performanceMetrics = {
      loadTime: window.performance.timing.loadEventEnd - window.performance.timing.navigationStart,
      domInteractive: window.performance.timing.domInteractive - window.performance.timing.navigationStart,
      firstPaint: performance.getEntriesByType('paint')[0]?.startTime,
    };

    // Combine all data
    const eventData = {
      ...data,
      ...timing,
      performanceMetrics,
      userAgent: navigator.userAgent,
      screenResolution: `${window.screen.width}x${window.screen.height}`,
      viewportSize: `${window.innerWidth}x${window.innerHeight}`,
      language: navigator.language,
    };

    // Send to analytics endpoint (implement your own)
    // await fetch('/api/analytics', {
    //   method: 'POST',
    //   body: JSON.stringify(eventData),
    // });
  }, []);

  return { trackEvent };
}